import { Document, Page, View } from '@react-pdf/renderer';

import {
  InvoiceAddressSection,
  InvoiceBrokerNotesSection,
  InvoiceFooter,
  InvoiceHeaderSection,
  InvoiceMetadataRow,
  InvoiceOrderDetailTable,
  InvoicePaymentInfoSection,
} from './RetailInvoicePDF.components';
import { styles } from './RetailInvoicePDF.css';
import { RetailInvoicePDFProps } from './RetailInvoicePDF.types';

export const RetailInvoicePDF = (props: RetailInvoicePDFProps) => {
  const {
    brokerName,
    brokerCompany,
    brokerAddress,
    brokerEmail,
    buyerName,
    buyerCompany,
    buyerEmail,
    buyerAddress,
    invoiceNumber,
    invoiceDate,
    currency,
    paymentTermsDays,
    lineItems,
    paymentMethod,
    paymentReference,
    brokerNotes,
    status,
    totalAmount,
    balanceDue,
    balanceDueDate,
    paymentsMade,
    orderDetailRows,
    labels,
  } = props;

  const subtotal = lineItems.reduce((sum, item) => sum + item.amount, 0);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header: Logo + INVOICE title + status badge + total */}
        <InvoiceHeaderSection
          status={status}
          totalAmount={subtotal}
          currency={currency}
          balanceDue={balanceDue}
          labels={labels}
        />

        {/* Orange divider */}
        <View style={styles.divider} />

        {/* Metadata row: Invoice #, Date, Payment Terms, Currency */}
        <InvoiceMetadataRow
          invoiceNumber={invoiceNumber}
          invoiceDate={invoiceDate}
          paymentTermsDays={paymentTermsDays}
          currency={currency}
          labels={labels}
        />

        {/* FROM / BILLED TO */}
        <InvoiceAddressSection
          brokerName={brokerName}
          brokerCompany={brokerCompany}
          brokerAddress={brokerAddress}
          brokerEmail={brokerEmail}
          buyerName={buyerName}
          buyerCompany={buyerCompany}
          buyerEmail={buyerEmail}
          buyerAddress={buyerAddress}
          labels={labels}
        />

        {/* Order Detail Table */}
        <InvoiceOrderDetailTable
          lineItems={lineItems}
          totalAmount={totalAmount}
          balanceDue={balanceDue}
          balanceDueDate={balanceDueDate}
          currency={currency}
          status={status}
          paymentsMade={paymentsMade}
          orderDetailRows={orderDetailRows}
          labels={labels}
        />

        {/* Payment Info & Terms */}
        <InvoicePaymentInfoSection
          paymentMethod={paymentMethod}
          paymentReference={paymentReference}
          labels={labels}
        />

        {/* Broker Notes */}
        <InvoiceBrokerNotesSection brokerNotes={brokerNotes} labels={labels} />

        {/* Footer */}
        <InvoiceFooter />
      </Page>
    </Document>
  );
};
